import { userService } from "../services";
import config from "../config/config";

export const DailyDistanceReportData = {
  fetchDailyDistanceReport,
};

async function fetchDailyDistanceReport(payload, pageType = "SUMMARY_REPORT") {
  try {
    let apiEndpoint = `${JSON.parse(localStorage.getItem("config")).baseUrl}${config.apiName.dailyDistanceReport}?page=${pageType}`;

    let response = await userService.post(apiEndpoint, payload);

    if (response && response.status == 200) {
      return response.data;
    } else {
      if (response.status == 401) {
        alert(response.data.message);
      }
      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}
